<template>
  <div>
    <a-card class="mcdm m-height-full m-display-flex flex-column">
      <div slot="title">
        <div class="m-display-flex space-between">
          <div>
            <span>COP Deduction Manifest - {{ moment(dataSource.header.periode,'YYYY-MM').format('MMMM YYYY') }}</span>
          </div>
          <a-popover slot="extra" trigger="click" placement="bottomRight">
            <span slot="title">Select Action</span>
            <ul class="m-list-wrapper bordered" slot="content">
              <li v-if="getAuth.username == dataSource.header.create_by">
                <a-button-group>
                  <a-button
                    :disabled="dataSource.header.status=='1'"
                    type="dashed"
                    icon="edit"
                    @click="handleEdit"
                    >Edit</a-button
                  >
                  <a-button
                    @click="handleDelete"
                    :disabled="dataSource.header.status=='1'"
                    type="danger"
                    icon="close-square"
                    :loading="loading.delete"
                    >Delete</a-button
                  >
                </a-button-group>
              </li>
            </ul>
            <a-button icon="more" :loading="loading.delete">Action</a-button>
          </a-popover>
        </div>
      </div>
      <template slot="extra">
      </template>
      <a-spin
        :spinning="loading.page"
        tip="Preparing To Show Data ...  "
      >
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Description</span>
                <span class="m-list-desc">{{ dataSource.header.description }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Create Date | TLC</span>
                <span class="m-list-desc">{{ moment(dataSource.header.tgl_buat).format('DD-MM-YYYY') }} | {{ dataSource.header.create_by }}</span>
              </li>
            </ul>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Status</span>
                <span class="m-list-desc">
                  <a-tag v-if="dataSource.header.status_label=='Open'" color="green">{{ 
                    dataSource.header.status_label?dataSource.header.status_label.toUpperCase():'' }}</a-tag>
                  <a-tag v-else color="red">{{ dataSource.header.status_label?dataSource.header.status_label.toUpperCase():'' }}</a-tag>
                </span>
              </li>
              <li v-if="dataSource.header.lampiran">
              <span class="m-list-title" for>File Excel</span>
              <span class="m-list-desc">
                <a-button type="link" style="padding:0px" @click="downloadFile">{{dataSource.header.lampiran}}</a-button>
              </span>
            </li>
            </ul>
          </a-col>
        </a-row>
        <a-table
          class="ccd margin-top"
          :columns="columns"
          :rowKey="(record, index) => {return index;}"
          :dataSource="dataSource.data"
          :pagination="false"
          size="small"
          :scroll="{ x: 750, y: 400 }"
          bordered
          :rowClassName="(record) => {return Number(record.jumlah)==Number(record.jumlah_sebelum)?
            'r_same' : 'r_not_same'}"
        >
          <template slot="title">
            <a-row :gutter="16" type="flex" justify="space-between" align="middle">
              <a-col>
                <div class="ant-card-head-title" ><b>Deduction Detail</b></div>
              </a-col>
              <a-col>
                <a-input-search
                  v-model="search"
                  placeholder="Search Deduction Detail .. "
                />  
              </a-col>
            </a-row>
          </template>
          <template slot="no" slot-scope="text, data, index">
            {{ index + 1 }}
          </template>
          <template slot="subsidi" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.subsidi"
            />
          </template>
          <template slot="potongan" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.potongan"
            />
          </template>
          <template slot="biaya_pendaftaran" slot-scope="item">
            <CurrencyJustified
              currencyValue="IDR"
              :valueNumber="item.daftar"
            />
          </template>
          <template slot="deskripsi" slot-scope="item">
            {{ item.keterangan }}
          </template>
          <template slot="footer">
            <a-row :gutter="16">
              <a-col xs="{ span: 24 }" :lg="{ span: 12 }">
                <div><b><small>Color Desc:</small></b></div>
                <div style="display:flex;vertical-align: middle;margin-top:5px;margin-bottom:25px"><div class="r_not_same" style="width:20px;height: 100%;">&nbsp;</div><small>&nbsp;has a different amount of COP subsidy or COP discount compared to the previous month's period</small></div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-row :gutter="16" type="flex" justify="end" align="top" class="">
                  <a-col style="display:flex;gap:16px">
                    <a-statistic title="Total amount of COP subsidy (IDR)" :value="total_subsidy" style="text-align: right;"/>
                  </a-col>
                  <a-col style="display:flex;gap:16px">
                    <a-statistic title="Total amount of COP deductions (IDR)" :value="total_deduction" style="text-align: right;"/>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </template>
        </a-table>
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

moment.locale('en')

export default {
  name: "cop-deduction-create",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  props: ["id"],
  data(){
    return {
      loading: {
        page: false,
        delete: false
      },
      dataSource: {
        header: [],
        data: [],
        dataOriginal: []
      },
      search: "",
      total_deduction: 0,
      total_subsidy: 0
    }
  },
  mounted(){
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
    ]),
    columns(){
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: "60px",
          align: "right",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "100px",
          align: "center",
        },
        {
          title: "COP Subsidies",
          key: "subsidi",
          width: "170px",
          scopedSlots: { customRender: "subsidi" },
        },
        {
          title: "COP Deductions",
          key: "potongan",
          width: "170px",
          scopedSlots: { customRender: "potongan" },
        },
        {
          title: "Description",
          key: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
        },
      ]
        return kolom
    }
  },
  methods:{
    moment,
    fetchData(){
      this.loading.page = true
      this.asyncAxiosGet("payment_cop",
        this.getAuth,
        { id_payment: this.id}
      )
      .then((response) => {
        this.dataSource.data = response.dtl
        this.dataSource.header = response.header
        this.dataSource.dataOriginal = this.dataSource.data

        this.total_deduction = response.header.total_potongan
        this.total_subsidy = response.header.total_subsidi
        this.lock_header = true
        this.loading.page = false
      })
      .catch((err) => {
        console.log(err);
      });
    },
    downloadFile(){
      window.open(this.$serviceUrl + this.dataSource.header.lampiran_path);
    },
    handleEdit(){
      this.$router.push({
        name: "copDeductionEdit",
        params: { id: this.id },
      });
    },
    handleDelete(){
      const that = this;
      let title = "";
      title = "Are you sure to delete this data?";
      that.$confirm({
        title: title,
        content: "Yes / No?",
        okText: "Yes",
        cancelText: "No",
        onOk() {


          that.loading.delete = true
          that.asyncAxiosDelete(
            "payment_cop",
            "application/json",
            that.getAuth,
            {
              id_payment: that.id
            }
          )
          .then(() => {
            that.displayMessage("success-delete")
            that.$router.push({ name: "CopList" });
          })
          .catch(() => {
            that.loading.delete = false
          });
        },
        onCancel() {},
      })
    }
  },
  watch:{
    "search"(val){
      if(val){ 
        this.dataSource.data = this.dataSource.dataOriginal.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.data = this.dataSource.dataOriginal
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ccd:deep{
  .ant-table-body{
    thead {
      th {
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="less">
  .mcdm{
    .ant-card-head-title{
      margin-right:0px
    }
  }

  .r_same { 
    background-color: fade(@color-secondary, 35%)!important;
  }

  .r_not_same { 
    background-color: fade(@color-primary, 35%)!important;
  }
</style>